import React, { useState } from "react";
import "./helpdesk.css";
import Header from "../../Components/Header";
import { ChevronDown, ChevronUp } from "lucide-react";

const HelpDesk = () => {
  const [visibleSection, setVisibleSection] = useState("");
  const [openSection, setOpenSection] = useState(5);

  const showSection = (sectionId) => {
    setVisibleSection(sectionId); // Set the clicked section as visible
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <>
      {/* Hero Section */}
      <Header heading="Help Desk" />
      <div
        className="hero"
        style={{
          background: 'url("assets/images/desk.jpg")',
          height: "20rem",
          width: "100%",
        }}
      >
        <h1 className="mt-2 text-blue-500">
          H<span className="text-yellow-500">e</span>lpd
          <span className="text-yellow-600">e</span>sk
        </h1>
        <p>Dashboard / Helpdesk</p>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search here"
            className="form-control inline-block ml-16 shadow-inner border border-blue-600"
            style={{
              borderColor: "rgb(15, 15, 242)",
              boxShadow:
                "inset 0px 35px 25px #dddee1e0, inset 10px 0px 25px #0000004b, inset 40px 0px 20px #fff, inset -10px 0px 25px #0000004b, inset -40px 0px 20px #cbced7, inset 0px 10px 10px #000000e0, inset 0px -15px 25px #00000036, 10px 25px 40px -10px #00000060",
            }}
          />
          <button className="bg-blue-800 rounded-md text-white hover:text-black hover:bg-blue-500 py-2 px-3">
            Search
          </button>
        </div>
      </div>
      {/* Content Section */}
      <div className="container mx-auto pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("firstcontainer")}
              >
                Getting Started FAQs
              </button>
            </h5>
            <p className="p-4">(Frequently Asked Questions)</p>
          </div>
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("secondcontainer")}
              >
                User Account Terms
              </button>
            </h5>
            <p className="p-4">Terms and Conditions agreement</p>
          </div>
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("thirdcontainer")}
              >
                Product Contacts
              </button>
            </h5>
          </div>
        </div>

        {/* Sections to be shown/hidden */}

        {/* Sections to be shown based on state */}
        {visibleSection === "firstcontainer" && (
          <div className="mt-4">
            <div className="accordion">
              {/* faq starts here */}

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full flex items-center justify-between text-left bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(5)}
                  >
                    <h5>What is IDSPay API?</h5>
                    {openSection === 5 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 5 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay API is a secure fintech API platform that allows
                        businesses to integrate financial, banking, KYC, and
                        verification services into their applications through
                        simple REST APIs. It helps automate processes like
                        identity verification, payment validation, and
                        compliance checks
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* FAQs #3 */}
              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(3)}
                  >
                    <h5>Is digital KYC is mandatory before using the API?</h5>
                    {openSection === 3 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 3 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, As per the new update from the regulatory Digital
                        KYC is required before accessing the API Services.{" "}
                        <br />
                        👉 <strong>Reason :</strong> RBI & NPCI regulations
                        require only verified entities to use such APIs because
                        they access financial/personal data.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(4)}
                  >
                    <h5>How can I add the balance in API wallet?</h5>
                    {openSection === 4 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 4 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        You can add the balance in API by using UPI QR & Bank
                        Transfer Methods, Be Careful we will not adjust or
                        settle back or refund your API wallet balance once you
                        added, so add a limited or required amount to API
                        wallet. If you have added balance in API Wallet means
                        you have to use the service only.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(6)}
                  >
                    <h5>Which services are available through IDSPay APIs?</h5>
                    {openSection === 6 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 6 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay offers a wide range of APIs including PAN
                        verification, bank account verification, IFSC
                        validation, AEPS services, UPI APIs, auto-debit
                        solutions, wallet services, and other utility APIs
                        required by fintech and enterprise businesses.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(7)}
                  >
                    <h5>Who is eligible to use IDSPay APIs? Answer:</h5>
                    {openSection === 7 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 7 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay APIs are designed for fintech companies,
                        startups, NBFCs, software companies, aggregators,
                        merchants, and enterprises. All users must complete
                        mandatory onboarding and compliance verification before
                        live API access is granted.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(8)}
                  >
                    <h5>How secure are IDSPay APIs?</h5>
                    {openSection === 8 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 8 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay APIs follow industry-standard security protocols
                        including encrypted communication, secure API
                        authentication, and controlled access mechanisms. This
                        ensures complete data privacy, transaction safety, and
                        protection against unauthorized access.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(9)}
                  >
                    <h5>HHow can I get IDSPay API access?</h5>
                    {openSection === 9 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 9 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        To access IDSPay APIs, you need to create an account,
                        submit required KYC and business documents, and request
                        the desired API services. Once approved, API keys and
                        documentation are shared for integration.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(10)}
                  >
                    <h5>How long does IDSPay API activation take?</h5>
                    {openSection === 10 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 10 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        API activation usually takes 24 to 72 working hours,
                        depending on document verification, compliance approval,
                        and the selected API modules. In some cases, activation
                        may be faster for pre-verified businesses.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(11)}
                  >
                    <h5>Is there a sandbox or test environment available?</h5>
                    {openSection === 11 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 11 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay provides a sandbox or test environment that
                        allows developers to test API integration, responses,
                        and error handling before moving to the production
                        environment.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(12)}
                  >
                    <h5>What pricing model does IDSPay follow?</h5>
                    {openSection === 12 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 12 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay follows a transparent, usage-based pricing model
                        where businesses are charged per API hit or transaction.
                        Pricing varies depending on the API type, volume, and
                        service category.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(13)}
                  >
                    <h5>Does IDSPay provide technical support?</h5>
                    {openSection === 13 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 13 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay offers dedicated technical support, complete
                        API documentation, and integration assistance. Support
                        is available during onboarding, testing, and
                        post-deployment to ensure smooth operations.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(14)}
                  >
                    <h5>
                      Can IDSPay APIs be customized as per business needs?
                    </h5>
                    {openSection === 14 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 14 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay APIs can be customized based on specific
                        business requirements, transaction volumes, and use
                        cases. Custom pricing, API responses, and service
                        configurations may be offered subject to feasibility and
                        compliance.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* More FAQs */}
            </div>
          </div>
        )}

        {/* {visibleSection === 'secondcontainer' && (
          <div className="mt-4">
            <div className="p-12 shadow-inner">
              <h2 className="text-center text-blue-500 underline">
                User Account Terms
              </h2>
              <div>
                <h5>termsphrase [ plural ]Add to word list B2</h5>
                 {openSection === 5 ?
                  <ChevronUp/> : <ChevronDown/>
                  }
                <div>
                  <span className="text-blue-500">*</span> the conditions that
                  control an agreement, arrangement, or activity:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> terms and conditions This
                  competition is only open to UK residents. Terms and conditions may
                  apply.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> the conditions that control
                  an agreement, arrangement, or activity:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> terms of She broke her
                  terms of employment by leaving without giving notice.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> They are claiming that he
                  broke the terms of a confidentiality agreement that he signed with
                  the couple.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> They had agreed to the
                  terms of the previous contract.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> We will then be in a better
                  position to dictate the terms of the sale.:
                </div>
              </div>
            </div>
          </div>
        )} */}

      {visibleSection === "thirdcontainer" && (
  <div className="w-full max-w-5xl mx-auto px-4 py-6">
    {/* Section Header */}
    <div className="text-center mb-8">
      <h4 className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-1">
        Support Center
      </h4>
      <h5 className="text-xl font-bold text-slate-800 tracking-tight">
        Product Features Support
      </h5>
    </div>

    {/* Responsive Grid Layout */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
      
      {/* Card 1: Sales / New Projects */}
      <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 transition-all duration-300 hover:shadow-md flex flex-col justify-between">
        <div>
          {/* Header */}
          <h5 className="text-slate-800 font-semibold text-lg tracking-tight mb-5 flex items-center gap-2">
            <span className="w-1.5 h-5 bg-indigo-600 rounded-full"></span>
            Discuss New Projects or APIs
          </h5>

          {/* Contact Content */}
          <div className="flex flex-col gap-4 text-sm text-slate-600">
            
            {/* Primary Phone & WhatsApp Row */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 bg-slate-50 rounded-xl border border-slate-100">
              <a 
                href="tel:+919113722202" 
                className="flex items-center gap-2 font-medium text-slate-700 hover:text-indigo-600 transition-colors group"
              >
                <span className="text-xs bg-slate-200 text-slate-600 font-bold px-1.5 py-0.5 rounded tracking-wide group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">IND</span>
                +91 91137 22202
              </a>
              
              <a 
                href="https://wa.me/919113722202"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 font-semibold px-3 py-1.5 rounded-lg text-xs transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.52 3.48A11.91 11.91 0 0 0 12.05 0C5.4 0 .03 5.37.03 12c0 2.12.55 4.2 1.6 6.04L0 24l6.12-1.6A11.94 11.94 0 0 0 12.05 24c6.65 0 12.02-5.37 12.02-12 0-3.2-1.25-6.22-3.55-8.52zM12.05 21.8c-1.82 0-3.6-.49-5.16-1.42l-.37-.22-3.63.95.97-3.54-.24-.37A9.77 9.77 0 0 1 2.27 12c0-5.4 4.39-9.8 9.78-9.8 2.61 0 5.06 1.02 6.9 2.86a9.7 9.7 0 0 1 2.86 6.9c0 5.4-4.39 9.8-9.76 9.8zm5.36-7.32c-.29-.14-1.72-.85-1.99-.95-.27-.1-.46-.14-.66.14-.19.29-.76.95-.93 1.15-.17.19-.34.22-.63.07-.29-.14-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.44.12-.58.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.14-.66-1.6-.91-2.2-.24-.58-.48-.5-.66-.51h-.56c-.19 0-.51.07-.77.36-.27.29-1.02 1-1.02 2.43s1.04 2.82 1.19 3.02c.14.19 2.05 3.13 4.97 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.12.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.19-.56-.33z"/>
                </svg>
                WhatsApp
              </a>
            </div>

            {/* Secondary Phone & WhatsApp Row */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 bg-slate-50/60 rounded-xl border border-slate-100">
              <a 
                href="tel:+919153988494" 
                className="flex items-center gap-2 font-medium text-slate-700 hover:text-indigo-600 transition-colors group"
              >
                <span className="text-xs bg-slate-100 text-slate-500 font-bold px-1.5 py-0.5 rounded tracking-wide group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">IND</span>
                +91 91539 88494
              </a>

              <a 
                href="https://wa.me/919153988494"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 bg-slate-100 hover:bg-emerald-50 text-slate-600 hover:text-emerald-700 font-medium px-3 py-1.5 rounded-lg text-xs transition-colors"
              >
                WhatsApp
              </a>
            </div>

            {/* Email Detail */}
            <div className="px-3 py-2 border-t border-slate-100 mt-1 flex flex-col gap-0.5">
              <span className="text-xs text-slate-400 font-medium uppercase tracking-wider">Email ID</span>
              <a href="mailto:Sales@idspay.in" className="text-slate-700 font-medium hover:text-indigo-600 transition-colors">
                Sales@idspay.in
              </a>
            </div>
          </div>
        </div>

        {/* Region Disclaimer */}
        <p className="mt-4 text-xs text-slate-400 leading-relaxed italic bg-slate-50/50 p-3 rounded-xl border border-dashed border-slate-200">
          * Clients from Nepal & Bhutan can exclusively consult via WhatsApp or Email channels.
        </p>
      </div>

      {/* Card 2: API Support Department */}
      <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 transition-all duration-300 hover:shadow-md flex flex-col justify-between">
        <div>
          {/* Header */}
          <h5 className="text-slate-800 font-semibold text-lg tracking-tight mb-5 flex items-center gap-2">
            <span className="w-1.5 h-5 bg-indigo-600 rounded-full"></span>
            API Support Department
          </h5>

          {/* Contact Content */}
          <div className="flex flex-col gap-4 text-sm text-slate-600">
            
            {/* Primary Phone & WhatsApp Row */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 bg-slate-50 rounded-xl border border-slate-100">
              <a 
                href="tel:+918603693666" 
                className="flex items-center gap-2 font-medium text-slate-700 hover:text-indigo-600 transition-colors group"
              >
                <span className="text-xs bg-slate-200 text-slate-600 font-bold px-1.5 py-0.5 rounded tracking-wide group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">IND</span>
                +91 86036 93666
              </a>
              
              <a 
                href="https://wa.me/918603693666"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 font-semibold px-3 py-1.5 rounded-lg text-xs transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.52 3.48A11.91 11.91 0 0 0 12.05 0C5.4 0 .03 5.37.03 12c0 2.12.55 4.2 1.6 6.04L0 24l6.12-1.6A11.94 11.94 0 0 0 12.05 24c6.65 0 12.02-5.37 12.02-12 0-3.2-1.25-6.22-3.55-8.52zM12.05 21.8c-1.82 0-3.6-.49-5.16-1.42l-.37-.22-3.63.95.97-3.54-.24-.37A9.77 9.77 0 0 1 2.27 12c0-5.4 4.39-9.8 9.78-9.8 2.61 0 5.06 1.02 6.9 2.86a9.7 9.7 0 0 1 2.86 6.9c0 5.4-4.39 9.8-9.76 9.8zm5.36-7.32c-.29-.14-1.72-.85-1.99-.95-.27-.1-.46-.14-.66.14-.19.29-.76.95-.93 1.15-.17.19-.34.22-.63.07-.29-.14-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.44.12-.58.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.14-.66-1.6-.91-2.2-.24-.58-.48-.5-.66-.51h-.56c-.19 0-.51.07-.77.36-.27.29-1.02 1-1.02 2.43s1.04 2.82 1.19 3.02c.14.19 2.05 3.13 4.97 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.12.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.19-.56-.33z"/>
                </svg>
                WhatsApp
              </a>
            </div>

            {/* Secondary Phone */}
            <div className="px-3 py-1 flex items-center gap-2">
              <a 
                href="tel:+917782005449" 
                className="flex items-center gap-2 font-medium text-slate-700 hover:text-indigo-600 transition-colors group"
              >
                <span className="text-xs bg-slate-100 text-slate-500 font-bold px-1.5 py-0.5 rounded tracking-wide group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">IND</span>
                +91 77820 05449
              </a>
            </div>

            {/* Email Detail */}
            <div className="px-3 py-2 border-t border-slate-100 mt-1 flex flex-col gap-0.5">
              <span className="text-xs text-slate-400 font-medium uppercase tracking-wider">Email ID</span>
              <a href="mailto:support@idspay.in" className="text-slate-700 font-medium hover:text-indigo-600 transition-colors">
                support@idspay.in
              </a>
            </div>
          </div>
        </div>

        {/* Region Disclaimer */}
        <p className="mt-4 text-xs text-slate-400 leading-relaxed italic bg-slate-50/50 p-3 rounded-xl border border-dashed border-slate-200">
          * Only WhatsApp, Email, Ticket System, and Google Meet support will be available for Nepal & Bhutan clients.
        </p>
      </div>

    </div>
  </div>
)}
      </div>
    </>
  );
};

export default HelpDesk;
